export const homeServiceIniValues = {
  title: "",
  icon: "",
  _id: "",
};
